// extracted by mini-css-extract-plugin
export default {"full-color-section":"full-color-section_full-color-section__CZ5-k","green":"full-color-section_green__EZbV4","blue":"full-color-section_blue__N05jL"};